// Diş modülü (liteapp) ortak sabitleri ve yardımcıları.

// Hizmet Seçimi penceresindeki fiyat / kur / indirim / vadeli fiyat alanlarını ve
// ekrandaki tutar gösterimlerini açıp kapatan tek anahtar. Talep sahibi bu alanların
// Vega'da da olmasını istedi, varsayılan açık. `false` yapılırsa alanlar gizlenir ama
// satırlar yine hizmetin liste fiyatıyla (clientapp ve liteapp sketch akışındaki gibi) kaydedilir.
export const TOOTH_TREATMENT_PRICING_ENABLED = true

export const TOOTH_IMAGE_CDN = 'https://s3.stellamedi.com/stellamedi-cdn/tooth/'

export const TOOTH_TEMPLATE = {
  permanent: 'permanent',
  primary: 'primary'
}

export const TOOTH_NOTE_MAX_LENGTH = 500
export const TREATMENT_NOTE_MAX_LENGTH = 750

// FDI, hekimin karşıdan baktığı görünüm: hastanın sağı ekranın solundadır.
// Kalıcı:  üst 18..11 | 21..28, alt 48..41 | 31..38
// Süt:     üst 55..51 | 61..65, alt 85..81 | 71..75
// (clientapp'in süt dişi alt sırası 75..71 | 85..81 idi; o hata burada tekrarlanmaz.)
const range = (quadrant, from, to) => {
  const list = []
  const step = from > to ? -1 : 1
  for (let i = from; step > 0 ? i <= to : i >= to; i += step) list.push(quadrant * 10 + i)
  return list
}

export const TOOTH_CHART_LAYOUT = {
  permanent: {
    upper: { right: range(1, 8, 1), left: range(2, 1, 8) },
    lower: { right: range(4, 8, 1), left: range(3, 1, 8) }
  },
  primary: {
    upper: { right: range(5, 5, 1), left: range(6, 1, 5) },
    lower: { right: range(8, 5, 1), left: range(7, 1, 5) }
  }
}

// CDN'deki diş görselleri soldan sağa sıralıdır: U1..U16 = 18..11,21..28 ve
// L1..L16 = 48..41,31..38. (Backend /Tooth/GetToothList alt-sol çeyrekte bu sırayı ters
// eşliyor; ekran oradan beslenmez.)
function permanentImageName(toothNumber) {
  const quadrant = Math.floor(toothNumber / 10)
  const position = toothNumber % 10
  switch (quadrant) {
    case 1: return 'U' + (9 - position)
    case 2: return 'U' + (8 + position)
    case 4: return 'L' + (9 - position)
    case 3: return 'L' + (8 + position)
    default: return null
  }
}

// Süt dişleri için ayrı görsel yok; her diş aynı çeyrekteki en yakın kalıcı dişin
// görseliyle çizilir (süt 1. azı -> 1. küçük azı, süt 2. azı -> 1. büyük azı).
const PRIMARY_TO_PERMANENT_POSITION = { 1: 1, 2: 2, 3: 3, 4: 4, 5: 6 }

export function toothImageUrl(toothNumber) {
  let number = toothNumber
  const quadrant = Math.floor(toothNumber / 10)
  if (quadrant >= 5) {
    number = (quadrant - 4) * 10 + PRIMARY_TO_PERMANENT_POSITION[toothNumber % 10]
  }
  const name = permanentImageName(number)
  return name ? TOOTH_IMAGE_CDN + name + '.png' : ''
}

// Backend tutarları "1234.5" biçiminde (nokta ondalık, binlik ayırıcı yok) okur ve yazar.
export function parseAmount(value) {
  if (value === null || value === undefined || value === '') return 0
  if (typeof value === 'number') return isNaN(value) ? 0 : value
  let text = value.toString().trim()
  // İki ayırıcı birlikte varsa sondaki ondalıktır ("1.234,5" ve "1,234.5" -> 1234.5).
  if (text.indexOf(',') !== -1 && text.indexOf('.') !== -1) {
    text = text.lastIndexOf(',') > text.lastIndexOf('.') ? text.replace(/\./g, '') : text.replace(/,/g, '')
  }
  const parsed = parseFloat(text.replace(',', '.'))
  return isNaN(parsed) ? 0 : parsed
}

export function formatAmount(value) {
  const amount = parseAmount(value)
  return amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

// clientapp'teki satır hesabıyla aynı: (vadeli ise kartlı fiyat) x miktar, ardından
// indirim ("%10" yüzde, "10" sabit tutar). Sonuç backend'in beklediği "1234.50" metnidir.
export function calculateRowTotal(row) {
  const entity = row.entity || {}
  const unitPrice = parseAmount(row.useCreditPrice ? entity.basePriceWithCard : entity.basePrice)
  let total = unitPrice * parseAmount(row.quantity)
  const discount = (row.userInputDiscount || '').toString().trim()

  if (discount.startsWith('%')) {
    const percent = parseAmount(discount.substring(1))
    total = total - ((total * percent) / 100)
  } else if (discount.length > 0) {
    total = total - parseAmount(discount)
  }

  return total.toFixed(2)
}

// Ana para birimine çevirme (clientapp ile aynı parite yönü).
export function convertToMainCurrency(amount, currencyId, mainCurrencyId, parityList) {
  const parity = (parityList || []).find(p => p.fromCurrencyId == mainCurrencyId && p.toCurrencyId == currencyId)
  return parseAmount(amount) * (parity ? parity.parity : 1)
}

// Modülün tüm onay pencereleri aynı görünümdedir; sonuç true/false döner.
export function confirmToothAction(vm, { title, text, confirmText, danger }) {
  return vm.$swal({
    icon: 'warning',
    title,
    text,
    confirmButtonText: danger ? '<i class="fa-regular fa-trash-can"></i> ' + (confirmText || vm.$t('Delete')) : confirmText,
    showCancelButton: true,
    cancelButtonText: vm.$t('Cancel'),
    reverseButtons: true,
    buttonsStyling: false,
    customClass: {
      confirmButton: 'btn btn-sm ml-2 ' + (danger ? 'btn-danger' : 'btn-primary'),
      cancelButton: 'btn btn-sm btn-light'
    }
  }).then(result => !!(result.isConfirmed || result.value))
}
